import { Link } from 'react-router-dom';
import { Headphones, Package, Sparkles, Archive, PackagePlus, Landmark } from 'lucide-react';

export default function HomePage({ tiles }) {

  const iconMap = {
    'categories': Package,
    'new': PackagePlus,
    'special-offers': Sparkles,
    'archived': Archive,
    'museum': Landmark
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-800">
      {/* Header */}
      <div className="bg-indigo-900 text-white p-6 shadow-lg">
        <div className="max-w-7xl mx-auto flex items-center space-x-3">
          <Headphones className="h-8 w-8" />
          <h1 className="text-2xl font-bold">All My Headphones Store</h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">

        {/* Responsive Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {tiles.map((tile) => {
            const Icon = iconMap[tile.id] || Package;

            return (
              <Link
                key={tile.id}
                to={tile.path}
                className="group relative bg-white dark:bg-gray-700 rounded-xl shadow-sm border border-gray-200 dark:border-gray-600 hover:shadow-lg hover:border-indigo-500 dark:hover:border-indigo-400 transition-all duration-300 overflow-hidden"
              >
                {/* Gradient overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/0 to-purple-500/0 group-hover:from-indigo-500/5 group-hover:to-purple-500/5 transition-all duration-300" />

                {/* Content — row on mobile, column on sm+ */}
                <div className="relative p-4 sm:p-6 flex flex-row sm:flex-col items-center sm:text-center gap-4 sm:gap-0 sm:space-y-3">
                  {/* Icon */}
                  <div className="w-14 h-14 shrink-0 sm:w-16 sm:h-16 rounded-full bg-white dark:bg-gray-700/50 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Icon className="h-7 w-7 sm:h-8 sm:w-8 text-indigo-600 dark:text-indigo-400" />
                  </div>

                  {/* Text */}
                  <div className="flex flex-col items-start sm:items-center text-left sm:text-center min-w-0">
                    <h3 className="text-base sm:text-lg font-semibold text-gray-800 dark:text-white">
                      {tile.title}
                    </h3>
                    <p className="text-sm text-gray-500 dark:text-gray-300 sm:whitespace-normal line-clamp-1 sm:line-clamp-none">
                      {tile.description}
                    </p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}